export default __webpack_public_path__ + "maps-overview-symbol-layer-960-583a86f892a6d312aef7b35b7902ca7a.png";